import React from "react";
import { TextField } from "@mui/material";
import { stepperTextFieldSx } from "../Tenant/stepperFormStyles";
import "./OrganizationInfoStep.css";

const CostInfoStep = ({ formik, organizationDataById }) => {
    return (
        <div className="org-step">
            <section className="org-step-section">
                <div className="org-step-section-head">
                    <h3>Subscription fees</h3>
                    <p>Platform setup and ongoing maintenance amounts.</p>
                </div>
                <div className="org-step-grid">
                    <div className="org-step-field">
                        <label htmlFor="cost-oneTimeSetupFee">
                            One-Time Platform Setup Fees
                        </label>
                        <TextField
                            id="cost-oneTimeSetupFee"
                            fullWidth
                            size="small"
                            name="oneTimeSetupFee"
                            sx={stepperTextFieldSx}
                            value={formik.values.oneTimeSetupFee}
                            onChange={(e) => {
                                const regex = /^\d*\.?\d{0,2}$/;
                                if (regex.test(e.target.value)) {
                                    formik.setFieldValue("oneTimeSetupFee", e.target.value);
                                }
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.oneTimeSetupFee && Boolean(formik.errors.oneTimeSetupFee)}
                            helperText={formik.touched.oneTimeSetupFee && formik.errors.oneTimeSetupFee}
                            inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9.]*",
                            }}
                            InputProps={{
                                startAdornment: (
                                    <span className="org-step-currency">$</span>
                                ),
                            }}
                        />
                    </div>

                    <div className="org-step-field">
                        <label htmlFor="cost-ongoingMaintenanceFee">
                            Ongoing Maintenance & Support
                        </label>
                        <TextField
                            id="cost-ongoingMaintenanceFee"
                            fullWidth
                            size="small"
                            name="ongoingMaintenanceFee"
                            sx={stepperTextFieldSx}
                            value={formik.values.ongoingMaintenanceFee}
                            onChange={(e) => {
                                const regex = /^\d*\.?\d{0,2}$/;
                                if (regex.test(e.target.value)) {
                                    formik.setFieldValue("ongoingMaintenanceFee", e.target.value);
                                }
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.ongoingMaintenanceFee && Boolean(formik.errors.ongoingMaintenanceFee)}
                            helperText={formik.touched.ongoingMaintenanceFee && formik.errors.ongoingMaintenanceFee}
                            InputProps={{
                                startAdornment: (
                                    <span className="org-step-currency">$</span>
                                ),
                            }}
                        />
                    </div>
                </div>
            </section>

            <section className="org-step-section">
                <div className="org-step-section-head">
                    <h3>Merchant fees</h3>
                    <p>Setup and support charges applied per merchant.</p>
                </div>
                <div className="org-step-grid">
                    <div className="org-step-field">
                        <label htmlFor="cost-newMerchantSetupFee">
                            New Merchant Setup Fee
                        </label>
                        <TextField
                            id="cost-newMerchantSetupFee"
                            fullWidth
                            size="small"
                            name="newMerchantSetupFee"
                            sx={stepperTextFieldSx}
                            value={formik.values.newMerchantSetupFee}
                            onChange={(e) => {
                                const regex = /^\d*\.?\d{0,2}$/;
                                if (regex.test(e.target.value)) {
                                    formik.setFieldValue("newMerchantSetupFee", e.target.value);
                                }
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.newMerchantSetupFee && Boolean(formik.errors.newMerchantSetupFee)}
                            helperText={formik.touched.newMerchantSetupFee && formik.errors.newMerchantSetupFee}
                            InputProps={{
                                startAdornment: (
                                    <span className="org-step-currency">$</span>
                                ),
                            }}
                        />
                    </div>

                    <div className="org-step-field">
                        <label htmlFor="cost-ongoingMaintenancePerMerchantFee">
                            Ongoing Maintenance & Support per Merchant
                        </label>
                        <TextField
                            id="cost-ongoingMaintenancePerMerchantFee"
                            fullWidth
                            size="small"
                            name="ongoingMaintenancePerMerchantFee"
                            sx={stepperTextFieldSx}
                            value={formik.values.ongoingMaintenancePerMerchantFee}
                            onChange={(e) => {
                                const regex = /^\d*\.?\d{0,2}$/;
                                if (regex.test(e.target.value)) {
                                    formik.setFieldValue("ongoingMaintenancePerMerchantFee", e.target.value);
                                }
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.ongoingMaintenancePerMerchantFee && Boolean(formik.errors.ongoingMaintenancePerMerchantFee)}
                            helperText={formik.touched.ongoingMaintenancePerMerchantFee && formik.errors.ongoingMaintenancePerMerchantFee}
                            InputProps={{
                                startAdornment: (
                                    <span className="org-step-currency">$</span>
                                ),
                            }}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CostInfoStep;
